module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qrepr2-744586b10f37a7767f5145749a37c3e7.jpg";